import { t } from 'i18next';
import type { ReactNode } from 'react';
import React, { createContext, useContext, useState } from 'react';

interface ConventionSignContextProps {
  children: ReactNode;
}

interface ConventionSignContextType {
  entitySignings: number;
  updateEntitySignings: () => void;
}

const ConventionSignContext = createContext<
  ConventionSignContextType | undefined
>(undefined);

export const useConventionSignContext = (): ConventionSignContextType => {
  const context = useContext(ConventionSignContext);
  if (!context) {
    throw new Error(t('convSignComp.contextError'));
  }
  return context;
};

export const ConventionSignProvider: React.FC<ConventionSignContextProps> = ({
  children,
}) => {
  const [entitySignings, setEntitySignings] = useState<number>(0);

  const updateEntitySignings = React.useCallback(() => {
    setEntitySignings((prev) => prev + 1);
  }, []);

  const contextValue = React.useMemo(
    () => ({ entitySignings, updateEntitySignings }),
    [entitySignings, updateEntitySignings]
  );

  return (
    <ConventionSignContext.Provider value={contextValue}>
      {children}
    </ConventionSignContext.Provider>
  );
};
